import { getSubcategoriesToSelect } from '../../../../actions/SubcategoriesActions';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import SubcategoriesContent from './SubcategoriesContent';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import CategoriesContent from './CategoriesContent';
import 'react-widgets/dist/css/react-widgets.css';
import docs from '../../../../config/docs';
import { Info } from '@material-ui/icons';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
import { connect } from 'react-redux';
import './Categories.scss';
const URL = docs.docsCategory;

class Categories extends Component {

	state = {
		categoriesVisible: true,
		tabIndex:          0,
		activeLoader:      true
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.getSubcategoriesToSelect();
	}

	componentDidUpdate(prevState) {}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	render() {
		if (this.props.subcategories) {
			return (
				<div className="main-content">
					<div className="malls-category-headers">
						Categorías
						<IconButton size="small">
							<Info onClick={() => this.redirectTo()} />
						</IconButton>
					</div>
					<div className="user-category-wrapper">
						<Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })} default={true}>
							<TabList >
								<Tab>Categorías</Tab>
								<Tab>Subcategorías</Tab>
							</TabList>
							<center>
								<TabPanel>
									<CategoriesContent subcategoriesToSelect={this.props.subcategories} />
								</TabPanel>
								<TabPanel>
									<SubcategoriesContent subcategoriesToSelect={this.props.subcategories} />
								</TabPanel>
							</center>
						</Tabs>
					</div>
				</div>
			);
		}
	}
}

const mapStateToProps = state => ({
	errors:        state.errors,
	subcategories: state.subcategory_reducer.subcategories,
	success:       state.success
});

export default connect(
	mapStateToProps,
	{
		getSubcategoriesToSelect
	}
)(Categories);
